
const AdminLogin = (credentials) => $Api.post( $ApiURL.auth.login, credentials );
const StudentLogin = (credentials) => $Api.post( $ApiURL.auth.studentLogin, credentials );
const InstructorLogin = (credentials) => $Api.post( $ApiURL.auth.InstructorLogin, credentials );
const StudentSignUp = (credentials) => $Api.post( $ApiURL.auth.studentSignUp, credentials );

const forgotPassword = email => $Api.post( $ApiURL.auth.sendResetLinkEmail, { email } );

const resetPassword = credentials => $Api.post( $ApiURL.auth.reset, credentials );



export {
    forgotPassword,
    resetPassword,
    AdminLogin,
    StudentLogin,
    InstructorLogin,
    StudentSignUp
}